import { render, staticRenderFns } from "./MapAttributions.vue?vue&type=template&id=5a6c015e&scoped=true&"
import script from "./MapAttributions.vue?vue&type=script&lang=js&"
export * from "./MapAttributions.vue?vue&type=script&lang=js&"
import style0 from "./MapAttributions.vue?vue&type=style&index=0&id=5a6c015e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6c015e",
  null
  
)

export default component.exports